import { Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import {
  NavigationEnd,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { environment } from '../environments/environment';
import { EnvironmentBannerComponent } from './components/environment-banner/environment-banner.component';
import { ToastMessageComponent } from './components/toast-message/toast-message.component';
import { ToastMessageService } from './services/toast-message.service';
import { SidenavComponent } from './sidenav/sidenav.component';
import { CoreStore } from './store/core.store';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    SidenavComponent,
    EnvironmentBannerComponent,
    ToastMessageComponent,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('admin-tool');
  protected readonly showEnvironmentBanner = environment.showEnvironmentBanner;
  private readonly router = inject(Router);
  private coreStore = inject(CoreStore);
  private toastService = inject(ToastMessageService);
  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter(
        (event): event is NavigationEnd | NavigationStart =>
          event instanceof NavigationEnd || event instanceof NavigationStart
      ),
      map((event) =>
        event instanceof NavigationEnd ? event.urlAfterRedirects : event.url
      ),
      startWith(this.router.url)
    ),
    { initialValue: this.router.url }
  );
  protected readonly isAccessDeniedRoute = computed(() => {
    const path = this.currentUrl().split(/[?#]/)[0].replace(/\/$/, '');
    return path === '/access-denied';
  });
}
